import React, { useReducer } from 'react';

// REDUX
import { getFixesState, setFixesState } from '@Managers/Redux/AppState/AppState';
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { IFixSelectorSimple } from '../Fixes.types';

// STYLES
import arrayCopy from '@Tools/ArrayCopy';
import styles from '../Fixes.scss';

const FixesSimpleSelector: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: IFixSelectorSimple, newState: {}) => ({ ...state, ...newState }), {
        fixString: ''
    });

    const dispatch = useAppDispatch();
    const fixesState = useAppSelector(getFixesState);

    function setFixString(evt: React.FormEvent<HTMLInputElement>) {
        setState({ fixString: evt.currentTarget.value });
    }

    function submitFixString(evt: React.KeyboardEvent<HTMLInputElement>) {
        if (evt.key === 'Enter') AddNew();
    }

    function AddNew() {
        if (state.fixString === 'v2') {
            dispatch(setFixesState({ extendedSelector: true }));
        } else {
            const _array = arrayCopy(fixesState.fixArray);
            const _combinatons = arrayCopy(fixesState.fixCombinations);
            const fixString = state.fixString;
            _array.push(fixString);
            _combinatons.push(fixString);
            setState({ fixString: '' });
            dispatch(setFixesState({ fixArray: _array, fixCombinations: _combinatons }));
        }
    }

    return (
        <>
            <div className={styles.fix_group}>
                <div className={styles.fix_group_header}>Fix List</div>
                <div className={styles.fix_group_options}>
                    <div className={styles.fix_group_option_item}>
                        <input type="text" onInput={(evt) => setFixString(evt)} value={state.fixString} onKeyDown={(evt) => submitFixString(evt)} />
                    </div>
                    <button className={styles.add_new_fix_btn} onClick={(evt) => AddNew()}>
                        +
                    </button>
                </div>
            </div>
        </>
    );
};

export default FixesSimpleSelector;
